module.exports = __webpack_public_path__ + "img/ent-pay.1f7638f5.png";